<template>
  <refonte-modal
    v-bind:show="props.show"
    class="!max-w-[1200px]"
    v-on:close="close">
    <template v-slot:modalHeader>
      <h1>Convocation</h1>
    </template>
    <template v-slot:modalBody>
      <template v-if="loading">
        <spinner
          sizes="w-20 h-20"
          thickness="border-8" />
      </template>
      <div
        class="flex h-full w-full flex-wrap"
        v-else>
        <div
          class="flex w-full flex-wrap space-y-2 px-4"
          v-if="convocations.length > 1">
          <span class="flex w-full">Liste des convocations</span>
          <ul class="list-inside list-disc">
            <li
              v-for="(convocation, index) in convocations"
              v-bind:class="`label ${index === currentConvocationIndex ? 'active' : ''}`"
              v-bind:key="`convocation-${index}`"
              v-on:click="currentConvocationIndex = index">
              {{ `Convocation ${index + 1}` }}
            </li>
          </ul>
        </div>
        <hr
          class="my-6 w-full text-core-900 opacity-50"
          v-if="convocations.length > 1" />
        <div
          v-if="convocations.length"
          class="flex w-full flex-wrap space-y-2 px-4">
          <div
            class="flex w-full flex-wrap"
            id="convocation">
            <div class="flex w-full flex-wrap">
              <span class="font-bold">Objet : &nbsp;</span
              >{{ convocations[currentConvocationIndex].objet }}
            </div>
            <div class="flex w-full flex-wrap">
              <div class="flex w-full font-bold">Message :</div>
              <div
                v-html="convocations[currentConvocationIndex].texte"
                class="mx-10 my-4 w-full border-2 border-core-300 bg-core-100 p-10 shadow"></div>
            </div>
          </div>
          <div
            class="flex w-full flex-wrap"
            v-if="
              convocations[currentConvocationIndex].piecesJointe &&
              convocations[currentConvocationIndex].piecesJointe.length > 0
            ">
            <div class="flex w-full font-bold">
              <font-awesome-icon
                class="mr-1"
                icon="paperclip"
                size="lg" />
              Pièces jointes
            </div>
            <ul class="list-inside list-disc">
              <li
                v-for="(pieceJointe, index) in convocations[
                  currentConvocationIndex
                ].piecesJointe"
                class="label"
                v-bind:key="`pj-${index}`"
                v-on:click="
                  () => downloadPieceJointe(pieceJointe.url, pieceJointe.nom)
                ">
                {{ pieceJointe.nom }}
              </li>
            </ul>
          </div>
          <div class="flex w-full justify-end">
            <refonte-button v-bind:on_click="() => printConvocation()">
              <font-awesome-icon icon="print" />
              Imprimer la convocation
            </refonte-button>
          </div>
        </div>
      </div>
    </template>
  </refonte-modal>
</template>

<script setup lang="ts">
  import RefonteButton from '@/components/refonte/buttons/refonte-button.vue';
  import RefonteModal from '@/components/refonte/modals/refonte-modal.vue';
  import spinner from '@/components/utils/spinner.vue';
  import { onMounted, ref } from 'vue';
  import { API } from '@/http-common';
  import { headerSkipRedirection } from '@/mixin/api_utils';

  const props = withDefaults(
    defineProps<{
      show: boolean;
      on_close: Function;
      class?: string;
      ressource_base_url: string;
    }>(),
    {
      class: ''
    }
  );

  function close() {
    props.on_close();
  }

  const currentConvocationIndex = ref(0);
  const loading = ref(false);
  const convocations = ref([]);

  const fetchConvocations = async () => {
    loading.value = true;
    const downloadUrl = `${import.meta.env.VITE_API_SAFIR}${props.ressource_base_url}/convocation`;
    const response = await API.get(downloadUrl, headerSkipRedirection);

    convocations.value =
      response.data && response.data.convocations
        ? response.data.convocations
        : [];
    loading.value = false;
  };

  const downloadPieceJointe = async (url, nom) => {
    const response = await API.get(`${url}`, {
      responseType: 'blob',
      ...headerSkipRedirection
    });
    const fileURL = window.URL.createObjectURL(new Blob([response.data]));
    const fileLink = document.createElement('a');

    fileLink.href = fileURL;
    fileLink.setAttribute('download', nom);
    document.body.appendChild(fileLink);
    fileLink.click();
  };

  onMounted(() => {
    fetchConvocations();
  });
</script>
<script lang="ts">
  export default {
    methods: {
      printConvocation() {
        this.$htmlToPaper('convocation');
      }
    }
  };
</script>

<style lang="scss" scoped>
  #convocation {
    :deep(a[href]) {
      @apply cursor-pointer text-jinius-dark-green hover:underline #{!important};
    }
  }

  .label {
    @apply cursor-pointer px-4 font-normal hover:font-bold hover:text-jinius-green;
    &.active {
      @apply font-bold text-jinius-green;
    }
  }
</style>
